const websiteConfig = {
  basic: {
    // 官网基础信息
    gameId: 263,
    packageName: "", // 配置微端端包名
    websiteId: "antslgofficial",
    title: "Ant Legion",
    description:
      "It’s such a big world for the tiny ants! However, with the right decisions, your swarm might be able to dominate someone’s backyard!",
    keywords:
      "super,ants,legion,bitsy,heros,iron,antman,strategy,planet,underground,kingdom,empires,vulcant,queen,worker,priest,soilder,army,free,wild,rules,best,adventure,social,wars,hunter,insect,predatron,arbalest,hellfire,gravedigger,dewdrop,brood,mother,kings,simulate,state,of,survival,age,z,last,shelter,empire,alliance,raid,shadow,legends,lords,mobile,royal,match,genshin,impact,topwar,avalon,guns,glory",
    review: true, // 是否审核模式，如果为true时，只有满足链接store=1时才会展示第三方储值相关
  },
  // 官网模块内容及顺序
  section: [
    "index", // 首屏
    "video", // 视频
    "news", // 新闻资讯
    "thirdParty", // 社群
    "role", // 角色
    "special", // 特色
  ],
  menu: {
    list: [
      // 导航栏配置：
      // name:显示名称
      // type: scroll: 滚动、 routeName：切换路由、link：链接外跳
      // target: 滚动的dom选择器或跳转链接
      // review: 是否判断审核状态，默认false
      {
        name: "home",
        type: "scroll",
        target: "#index",
      },
      {
        name: "news",
        type: "routeName",
        target: "List",
      },
      {
        name: "community",
        type: "scroll",
        target: "#thirdParty",
      },
      {
        name: "character",
        type: "scroll",
        target: "#role",
      },
      {
        name: "features",
        type: "scroll",
        target: "#special",
      },
      {
        name: "topUp",
        type: "link",
        target:
          "//pay.37games.com/platform/officialStore.html?gameId=263&cid=official&scid=titlebar#/",
        review: true,
      },
      {
        name: "customerService",
        type: "link",
        target:
          "//service.37games.com/platform/officialSupport.html?gameId=263",
      },
    ],
    safeDistance: 70, // 滚动安全区，单位px
    logo: new URL("@images/logo.png", import.meta.url),
    thirdParty: [
      // 菜单需展示的社群，同时关联PC/移动端导航弹窗，当种类数量大于1个时，会在右侧展示
      {
        type: "discord",
        update: false,
        link: "https://discord.gg/MqtEqkrBQU",
      },
      {
        type: "facebook",
        update: false,
        link: "https://www.facebook.com/antlegiongame/",
      },
      {
        type: "vk",
        update: true,
        link: "https://auto-page.37games.com/mayivk/",
      },
    ],
  },
  lang: {
    show: true, // 是否有多语言
    list: [
      //支持的语言选项
      {
        code: "en-US",
        name: "English",
      },
      {
        code: "ko-KR",
        name: "한국어",
      },
      {
        code: "ru-RU",
        name: "Русский",
      },
      {
        code: "fr-FR",
        name: "Français",
      },
      {
        code: "de-DE",
        name: "Deutsch",
      },
    ],
  },
  downloadLink: {
    // 下载链接，ios/android/sdk 默认会优先从gameInfo接口读取
    appstore: "//apps.apple.com/US/app/id1584078447?mt=8",
    googlePlay: "//play.google.com/store/apps/details?id=com.global.antgame",
    pcPlay: "", // gevents.37games.com/exe/dl3dth/Douluo Dalu : สัประยุทธ์วิญญาจารย์_install_2.0.0.exe
    apk: "//cdngdownloads.37games.com/com.global.antgame.apk",
    ldPlayer: "",
    yeshen: "",
    blueStack: "",
    default_qrcode: new URL("@images/list/qrcode.png", import.meta.url),
  },
  index: {
    // 首屏相关配置
    videoLink: "",
    bgm: "", // 背景音乐
    slogan: "",
    showMoreDownload: false,
  },
  videoLink: "yWKFun9whFQ", // 视频资讯
  news: {
    // 新闻资讯/文章列表配置
    defaultNewsPic: new URL(
      "@images/news/news_article_preview.jpg",
      import.meta.url
    ), // 新闻默认图片
    type: {
      "en-US": {
        "1318": "News",
        "1332": "Community",
        "1360,1374": "Ant Wiki",
      },
      "ru-RU": {
        "1329": "Новости",
        "1343": "Сообщество",
        "1367,1381": "Особая мурапедия",
      },
      "fr-FR": {
        "1325": "Nouvelles",
        "1339": "Communauté",
        "1368,1382": "Wiki Fourmi spécialisée",
      },
      "de-DE": {
        "1326": "Neuigkeiten",
        "1340": "Community",
        "1371,1385": "Spezial-Ameisen Wiki",
      },
      "ko-KR": {
        "1322": "정보",
        "1336": "커뮤니티",
        "1364,1378": "개미 세계 사전",
      },
    },
  },
  thirdParty: {
    // 社群相关配置
    supportArr: [
      // 支持的社群列表
      {
        type: "facebook",
        link: "https://www.facebook.com/antlegiongame/",
      },
    ],
    iframe: {
      // 只支持facebook/twitter
      type: "facebook", // 显示的社群主页插件
      link: "https://www.facebook.com/antlegiongame/",
      appId: "5101543013264586",
    },
  },
  role: {
    // 角色相关配置
    mainTitle: "specialAnt", // 主标题
    subTitle: "", // 副标题
    swiperType: "full", // full全屏 / normal普通
    langDiffs: true, // 是否包含多语言
    showSkillText: false,
    list: [
      {
        name: "ant", // 主模块名称
        roleInfo: [
          {
            name: "gongbei",
            desc: "gongbei_text",
            mediaType: "",
            url: "",
            avatar: new URL("@images/role/avatar_1.png", import.meta.url),
            pic: new URL("@images/role/char_1.jpg", import.meta.url),
            skill: [
              {
                name: "gongbei_skill1",
                pic: new URL("@images/skill/gong_speed.png", import.meta.url),
              },
              {
                name: "gongbei_skill2",
                pic: new URL(
                  "@images/skill/gong_food_down.png",
                  import.meta.url
                ),
              },
              {
                name: "gongbei_skill3",
                pic: new URL(
                  "@images/skill/gong_power_down.png",
                  import.meta.url
                ),
              },
            ],
          },
          {
            name: "hongyi",
            desc: "hongyi_text",
            cv: "",
            mediaType: "",
            url: "",
            avatar: new URL("@images/role/avatar_2.png", import.meta.url),
            pic: new URL("@images/role/char_2.jpg", import.meta.url),
            skill: [
              {
                name: "hongyi_skill1",
                pic: new URL("@images/skill/hong_speed.png", import.meta.url),
              },
              {
                name: "hongyi_skill2",
                pic: new URL("@images/skill/hong_train.png", import.meta.url),
              },
              {
                name: "hongyi_skill3",
                pic: new URL("@images/skill/hong_scale.png", import.meta.url),
              },
            ],
          },
          {
            name: "ciyi",
            desc: "ciyi_text",
            cv: "",
            mediaType: "",
            url: "",
            avatar: new URL("@images/role/avatar_3.png", import.meta.url),
            pic: new URL("@images/role/char_3.jpg", import.meta.url),
            skill: [
              {
                name: "ciyi_skill1",
                pic: new URL(
                  "@images/skill/ciyi_tacitics.png",
                  import.meta.url
                ),
              },
              {
                name: "ciyi_skill2",
                pic: new URL("@images/skill/ciyi_HP.png", import.meta.url),
              },
              {
                name: "ciyi_skill3",
                pic: new URL("@images/skill/ciyi_DEF.png", import.meta.url),
              },
              {
                name: "ciyi_skill4",
                pic: new URL("@images/skill/ciyi_ATK.png", import.meta.url),
              },
            ],
          },
          {
            name: "jinjia",
            desc: "jinjia_text",
            cv: "",
            mediaType: "",
            url: "",
            avatar: new URL("@images/role/avatar_4.png", import.meta.url),
            pic: new URL("@images/role/char_4.jpg", import.meta.url),
            skill: [
              {
                name: "jinjia_skill1",
                pic: new URL(
                  "@images/skill/jinjia_tacitics.png",
                  import.meta.url
                ),
              },
              {
                name: "jinjia_skill2",
                pic: new URL("@images/skill/jinjia_HP.png", import.meta.url),
              },
              {
                name: "jinjia_skill3",
                pic: new URL("@images/skill/jinjia_DEF.png", import.meta.url),
              },
              {
                name: "jinjia_skill4",
                pic: new URL("@images/skill/jinjia_ATK.png", import.meta.url),
              },
            ],
          },
          {
            name: "huoyi",
            desc: "huoyi_text",
            cv: "",
            mediaType: "",
            url: "",
            avatar: new URL("@images/role/avatar_5.png", import.meta.url),
            pic: new URL("@images/role/char_5.jpg", import.meta.url),
            skill: [
              {
                name: "huoyi_skill1",
                pic: new URL(
                  "@images/skill/huoyi_tacitics.png",
                  import.meta.url
                ),
              },
              {
                name: "huoyi_skill2",
                pic: new URL("@images/skill/huoyi_HP.png", import.meta.url),
              },
              {
                name: "huoyi_skill3",
                pic: new URL("@images/skill/huoyi_DEF.png", import.meta.url),
              },
              {
                name: "huoyi_skill4",
                pic: new URL("@images/skill/huoyi_ATK.png", import.meta.url),
              },
            ],
          },
        ],
      },
    ],
  },
  special: [
    // 游戏特色相关配置
    {
      name: "screenshot", // 主模块名称
      list: [
        {
          pic_default: new URL(
            "@images/special/en/special_en_0.jpg",
            import.meta.url
          ),
          pic_US: new URL(
            "@images/special/en/special_en_0.jpg",
            import.meta.url
          ),
          pic_FR: new URL(
            "@images/special/fr/special_fr_0.jpg",
            import.meta.url
          ),
          pic_RU: new URL(
            "@images/special/ru/special_ru_0.jpg",
            import.meta.url
          ),
          pic_DE: new URL(
            "@images/special/de/special_de_0.jpg",
            import.meta.url
          ),
          pic_KR: new URL(
            "@images/special/ko/special_ko_0.jpg",
            import.meta.url
          ),
        },
        {
          pic_default: new URL(
            "@images/special/en/special_en_1.jpg",
            import.meta.url
          ),
          pic_US: new URL(
            "@images/special/en/special_en_1.jpg",
            import.meta.url
          ),
          pic_FR: new URL(
            "@images/special/fr/special_fr_1.jpg",
            import.meta.url
          ),
          pic_RU: new URL(
            "@images/special/ru/special_ru_1.jpg",
            import.meta.url
          ),
          pic_DE: new URL(
            "@images/special/de/special_de_1.jpg",
            import.meta.url
          ),
          pic_KR: new URL(
            "@images/special/ko/special_ko_1.jpg",
            import.meta.url
          ),
        },
        {
          pic_default: new URL(
            "@images/special/en/special_en_2.jpg",
            import.meta.url
          ),
          pic_US: new URL(
            "@images/special/en/special_en_2.jpg",
            import.meta.url
          ),
          pic_FR: new URL(
            "@images/special/fr/special_fr_2.jpg",
            import.meta.url
          ),
          pic_RU: new URL(
            "@images/special/ru/special_ru_2.jpg",
            import.meta.url
          ),
          pic_DE: new URL(
            "@images/special/de/special_de_2.jpg",
            import.meta.url
          ),
          pic_KR: new URL(
            "@images/special/ko/special_ko_2.jpg",
            import.meta.url
          ),
        },
        {
          pic_default: new URL(
            "@images/special/en/special_en_3.jpg",
            import.meta.url
          ),
          pic_US: new URL(
            "@images/special/en/special_en_3.jpg",
            import.meta.url
          ),
          pic_FR: new URL(
            "@images/special/fr/special_fr_3.jpg",
            import.meta.url
          ),
          pic_RU: new URL(
            "@images/special/ru/special_ru_3.jpg",
            import.meta.url
          ),
          pic_DE: new URL(
            "@images/special/de/special_de_3.jpg",
            import.meta.url
          ),
          pic_KR: new URL(
            "@images/special/ko/special_ko_3.jpg",
            import.meta.url
          ),
        },
        {
          pic_default: new URL(
            "@images/special/en/special_en_4.jpg",
            import.meta.url
          ),
          pic_US: new URL(
            "@images/special/en/special_en_4.jpg",
            import.meta.url
          ),
          pic_FR: new URL(
            "@images/special/fr/special_fr_4.jpg",
            import.meta.url
          ),
          pic_RU: new URL(
            "@images/special/ru/special_ru_4.jpg",
            import.meta.url
          ),
          pic_DE: new URL(
            "@images/special/de/special_de_4.jpg",
            import.meta.url
          ),
          pic_KR: new URL(
            "@images/special/ko/special_ko_4.jpg",
            import.meta.url
          ),
        },
        {
          pic_default: new URL(
            "@images/special/en/special_en_5.jpg",
            import.meta.url
          ),
          pic_US: new URL(
            "@images/special/en/special_en_5.jpg",
            import.meta.url
          ),
          pic_FR: new URL(
            "@images/special/fr/special_fr_5.jpg",
            import.meta.url
          ),
          pic_RU: new URL(
            "@images/special/ru/special_ru_5.jpg",
            import.meta.url
          ),
          pic_DE: new URL(
            "@images/special/de/special_de_5.jpg",
            import.meta.url
          ),
          pic_KR: new URL(
            "@images/special/ko/special_ko_5.jpg",
            import.meta.url
          ),
        },
      ],
    },
  ],
  footer: {
    ageLimit: {
      show: false, // 是否展示年龄限制相关，若为false，可不填写对象内age及text内容
      age: "18", // -1:不展示  年龄分级：0 6 12 15 18
      text: [
        "*本遊戲內容涉及暴力（武俠動作）、角色穿著凸顯胸、臂之服飾",
        "*本遊戲部分內容需另行支付費用",
        "*請避免沉迷遊戲",
      ],
    },
    termArr: [
      // 包含条款 $HOST: 主域名
      {
        name: "fwtk",
        link: "https://gpassport.37games.com/center/ServicePrivacy/customize?keyWord=service_ant",
      },
      {
        name: "yszc",
        link: "https://gpassport.37games.com/center/ServicePrivacy/customize?keyWord=privacy_ant",
      },
    ],
  },
  articleBanner: new URL("@images/list/list_banner.jpg", import.meta.url),
  payAside: {
    show: true,
    payLink:
      "https://pay.37games.com/platform/officialStore.html?gameId=263&cid=official&scid=sidebar",
    guidePage: "https://auto-page.37games.com/antslg_store_guide/",
    default_bg: new URL("@images/aside/pay_aside_US.png", import.meta.url),
    bg_DE: new URL("@images/aside/pay_aside_DE.png", import.meta.url),
    bg_FR: new URL("@images/aside/pay_aside_FR.png", import.meta.url),
    bg_RU: new URL("@images/aside/pay_aside_RU.png", import.meta.url),
  },
};
export default websiteConfig;
